import "../../../css/DesignSystem/Inputs/InputField.css";
import Tooltip from "../Tooltip/Tooltip";
import { ReactComponent as InformationIcon } from "../../../assets/icons/information.svg";

const InputField = ({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  multiline = false,
  rows = 3,
  error = false,
  helperText,
  required = false,
  disabled = false,
  icon,
  readOnly = false,
  min,
  step,
  inputMode,
  tooltip,
  multiple = false,
}) => {
  const inputId = id || `input-${label?.replace(/\s+/g, "-")?.toLowerCase()}`;
  const inputName = name || id;

  // Wrapper function to ensure name is always present on the event
  const handleChange = (e) => {
    if (onChange) {
      // Patch the event if name is missing
      if (name && (!e.target.name || e.target.name !== name)) {
        // Patch the event.target.name property
        Object.defineProperty(e.target, "name", {
          value: name,
          configurable: true,
        });
      }
      onChange(e);
    }
  };

  return (
    <div className={`ds-input-field ${error ? "ds-input-field--error" : ""}`}>
      {label && (
        <div className="Content-Small ds-input-label-row">
          <label htmlFor={inputId}>
            {label}
            {required && (
              <span className="FP_Content_Semibold text-error">*</span>
            )}
          </label>
          {tooltip && (
            <Tooltip content={tooltip} position="top">
              <InformationIcon
                className="ds-input-tooltip-icon"
                aria-label={`${label} help`}
              />
            </Tooltip>
          )}
        </div>
      )}
      <div
        className={`Content ds-input-wrapper ${multiline ? "ds-input-wrapper--multiline" : ""}`}
      >
        {icon && <span className="ds-input-icon">{icon}</span>}
        {multiline ? (
          <textarea
            id={inputId}
            name={inputName}
            className="FP_Content ds-input ds-input-textarea"
            rows={rows}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
          />
        ) : (
          <input
            id={inputId}
            name={inputName}
            className="FP_Content ds-input ds-input-text"
            type={type}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            min={min}
            step={step}
            inputMode={inputMode}
            multiple={multiple}
          />
        )}
      </div>
      {/* {helperText && (
        <div
          className={`ds-input-helper ${error ? "ds-input-helper--error" : ""}`}
        >
          {helperText}
        </div>
      )} */}
    </div>
  );
};;

export default InputField;
